export default __webpack_public_path__ + "978af19.png";